import { FlexBox, Timestamp } from '@dixa/lib-shared-habla';
import type { ReadConversationsSortKey } from 'lib-shared-types-api';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableTimestamp.module.scss';

type ConversationsTableTimestampProps = {
  timestampKey: ReadConversationsSortKey;
};

/** Represents the content of a timestamp cell in the conversations table. */
export const ConversationsTableTimestamp = ({
  timestampKey,
}: ConversationsTableTimestampProps): JSX.Element => {
  const {
    conversationAndRequester: { conversation },
  } = useConversationRow();
  const timestamp = conversation[timestampKey];

  return (
    <FlexBox display="inline-flex" alignItems="center">
      {timestamp && (
        <Timestamp className={styles.timestamp} time={timestamp} relative />
      )}
    </FlexBox>
  );
};
